const textForDonation = {
  title: "Colabore con Somos más ONG",
  text: 'Si desea constribuir con nuestros proyectos, puede aportar su granito de arena. Sólo debe pulsar el botón “Donar” y rellenar los datos que requiera "Mercado Pago" y enviar su aporte.',
  ongText: "Somos más ONG",
  thanks: "Gracias por su colaboración",
  meliDonate: "Donar con MercadoPago",
  areYouSure: "¿Esta seguro de hacer una donación?",
};

export { textForDonation };
